import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { OfferOption, SelectedOffer } from '@utils/backend-api/subscribe';
import { SubscriptionStatus } from '@utils/interfaces';

import Content from './Content';

export interface DualSubscribeProps {
  billingAmountCBPT?: number;
  cbptTaxAmountExclusive?: number;
  cbptTotalWithTax?: number;
  defaultSelectedOffer: SelectedOffer;
  description?: string;
  dob: string;
  initialCurrentUser?: User;
  isDueInFuture: boolean;
  isGdprRequired: boolean;
  isNativeApp?: boolean;
  isWebview?: boolean;
  isYPEligible: boolean;
  latestTITVEpisodeID?: string;
  offers: OfferOption[];
  showExpressCheckout?: boolean;
  stripeCustomerId?: string;
  subscribePageExperiment?: string;
  subscribePrefillToken?: string;
  subscriptionStatus?: SubscriptionStatus;
  userDobVerified?: boolean;
  userEmail?: string;
  userFullName?: string;
  userId?: number;
  userNextBillingDate?: string;
}

const queryClient = new QueryClient();

const DualSubscribe = (props: DualSubscribeProps) => {
  const {
    isYPEligible,
    showExpressCheckout,
    stripeCustomerId,
    subscribePrefillToken,
    subscriptionStatus,
    userDobVerified,
    userEmail,
    userFullName,
    userId,
  } = props;
  const { Track } = useEventTracking({
    page: Page.DualSubscribe,
  });

  return (
    <AppContextProvider
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isNativeApp={props.isNativeApp}
      isWebview={props.isWebview}
    >
      <SubscribeFormProvider
        showExpressCheckout={showExpressCheckout}
        user={{
          dobVerified: userDobVerified,
          email: userEmail,
          id: userId,
          isYPEligible,
          name: userFullName,
          prefillToken: subscribePrefillToken,
          stripeCustomerId,
          subscriptionStatus,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Track>
            <Content {...props} />
          </Track>
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default DualSubscribe;
